module.exports = __webpack_public_path__ + "img/40.e16cbf7d.png";